import {Record, List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';
import {type RoleSource, type RoleTarget} from 'web-app/util/graphql/api-types';
import {type RoleSiteFragment} from 'web-app/react/manage-employees/roles/__generated__/queries.api-types';
import {type ValidInstitutionSetTypes} from 'web-app/react/manage-employees/roles/permission-role-form/helpers';
import * as Types from 'web-app/react/manage-employees/roles/permission-role-form/types';

import * as Actions from './actions';

export interface PermissionRoleModalStateProps {
    readonly isVisible: boolean;
    readonly roleIds?: List<string>;
    readonly institutionSetId?: string;
    readonly institutionSetType: ValidInstitutionSetTypes | undefined;
    readonly availableSites: RoleSiteFragment[];
    readonly source?: RoleSource;
    readonly target?: RoleTarget;
    readonly canCreateRoles: boolean;
    readonly canEditRoles: boolean;
    readonly mode: Types.PermissionRoleFormMode;
}
export class PermissionRoleModalState extends Record<PermissionRoleModalStateProps>({
    isVisible: false,
    roleIds: undefined,
    institutionSetId: undefined,
    institutionSetType: undefined,
    availableSites: [],
    source: undefined,
    target: undefined,
    canCreateRoles: false,
    canEditRoles: false,
    mode: Types.PermissionRoleFormMode.update,
}) {}

export default makeReducer<PermissionRoleModalState>(
    [
        match(
            Actions.show,
            (state, {payload}) =>
                new PermissionRoleModalState({
                    isVisible: true,
                    roleIds: payload.roleId ? List.of(payload.roleId) : undefined,
                    institutionSetId: payload.institutionSetId,
                    institutionSetType: payload.institutionSetType,
                    availableSites: payload.availableSites,
                    source: payload.source,
                    target: payload.target,
                    mode: payload.mode,
                    canCreateRoles: payload.canCreateRoles,
                    canEditRoles: payload.canEditRoles,
                }),
        ),
        match(Actions.hide, state =>
            state.merge({
                isVisible: false,
            }),
        ),
    ],
    new PermissionRoleModalState(),
);
